// https://vuex.vuejs.org/en/actions.html
import axios from '@/axios'

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      // axios.post('/auth', { username: userData.username, password: userData.password })
      axios.post('Usuario/Autenticar', { Usuario: userData.username, Password: userData.password }).then(response => {
          if(response.data.resultado===0){
            const token = response.data.datos.token;
            const user = response.data.datos.usuario;
            const username = response.data.datos.usuarioNombre;
            //const rolesuser = response.data.datos.roles[0].idrol
            const roluser = response.data.datos.idrolmaximo;
            const rolesuser = response.data.datos.idroles;
            const permisos = response.data.datos.permisos;
            const vencimiento = response.data.datos.validohasta;
            const foto = response.data.datos.foto;
            const idestado= response.data.datos.idestado;
            const iddelegacion= response.data.datos.iddelegacion;
            const mensaje= response.data.resultadomensaje;
            console.log(response)
            // storing jwt in localStorage. https cookie is safer place to store
            localStorage.setItem('token', token)
            localStorage.setItem('user', user)
            localStorage.setItem('username', username)
            localStorage.setItem('rolusuario', roluser)
            localStorage.setItem('rolesusuario', rolesuser)
            localStorage.setItem('permisos', permisos)
            localStorage.setItem('vencimiento', vencimiento)
            localStorage.setItem('foto', foto)
            localStorage.setItem('idestado', idestado)
            localStorage.setItem('iddelegacion', iddelegacion)
            localStorage.setItem('mensaje', mensaje)

            var lstrodid= JSON.stringify(rolesuser);
            localStorage.setItem('rolesid', lstrodid);

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            // mutation to change state properties to the values passed along

            if(idestado===1)
            {
              commit('auth_success', { token, user, username,roluser,rolesuser,lstrodid,permisos,vencimiento, foto, idestado,iddelegacion,mensaje })
              resolve(response)
            }else{
              commit('auth_error',mensaje);
              resolve(response);
            }
          }else{
            console.log('login error')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('username')
            localStorage.removeItem('rolusuario')
            localStorage.removeItem('rolesusuario')
            localStorage.removeItem('permisos')
            localStorage.removeItem('vencimiento')
            localStorage.removeItem('foto')
            localStorage.removeItem('idestado')
            localStorage.removeItem('iddelegacion')
            localStorage.removeItem('rolesid')
            const mensaje= response.data.resultadomensaje;
            localStorage.setItem('mensaje', mensaje)
            commit('auth_error',mensaje)
            reject(mensaje)
          }
      }).catch(err => {
        console.log('login error')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('username')
        localStorage.removeItem('rolusuario')
        localStorage.removeItem('rolesusuario')
        localStorage.removeItem('permisos')
        localStorage.removeItem('vencimiento')
        localStorage.removeItem('foto')
        localStorage.removeItem('idestado')
        localStorage.removeItem('iddelegacion')
        localStorage.removeItem('rolesid')
        localStorage.setItem('mensaje', err.message)
        commit('auth_error',err.message)
        reject(err)
      })
    })
  },
  logout ({ commit }) {
    // return new Promise((resolve, reject) => {
    return new Promise((resolve) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('username')
      localStorage.removeItem('rolusuario')
      localStorage.removeItem('rolesusuario')
      localStorage.removeItem('permisos')
      localStorage.removeItem('vencimiento')
      localStorage.removeItem('foto')
      localStorage.removeItem('idestado')
      localStorage.removeItem('iddelegacion')
      localStorage.removeItem('rolesid')
      localStorage.removeItem('mensaje')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },
  refreshtoken ({ commit }) {
    axios.get('/refresh')
      .then(response => {
        const token = response.data.access_token
        localStorage.setItem('token', token)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        commit('auth_success', { token })
      })
      .catch(error => {
        console.log('refresh token error')
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('username')
        localStorage.removeItem('rolusuario')
        localStorage.removeItem('rolesusuario')
        localStorage.removeItem('permisos')
        localStorage.removeItem('vencimiento')
        localStorage.removeItem('foto')
        localStorage.removeItem('idestado')
        localStorage.removeItem('iddelegacion')
        localStorage.removeItem('rolesid')
        localStorage.removeItem('mensaje')
        console.log(error)
      })
  }
  /* getTableList ({ commit }, tableName) {
    this.$http.get(`/${tableName}`)
      .then(response => {
        console.log(response)
        let tableList = response.data.Keys
        commit('setTableList', { tableList })
      })
      .catch(error => console.log(error))
  },
  updateTableItem ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({ url: `/${tableData.endpoint}`, method: httpmethod, data: tableData.tableItem })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  } */

//   autoRefreshToken ({ commit }) {
//     return new Promise((resolve, reject) => {
//       setInterval(function () {
//         // code goes here that will be run every 20 minutes.
//         axios.get('/refresh')
//           .then(response => {
//             const token = response.data.access_token
//             localStorage.setItem('token', token)
//             axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
//             commit('auth_success', { token })
//             resolve(response)
//           })
//           .catch(error => {
//             console.log('refresh token error')
//             console.log(error)
//             reject(error)
//           })
//       }, 120000)
//     }
//     )
//   },

}
